import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Layout } from "../../components/layout/index.ts";
import { Loader } from "../../components/Loader.tsx";
import { getTelegram } from "../../lib/telegram.ts";

const CARD_CLASS =
  "rounded-2xl overflow-hidden bg-white/95 shadow-sm border border-slate-100 ring-1 ring-slate-200/50";

export function PaymentThanksPage() {
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();
  const tg = getTelegram();

  // Setup BackButton
  useEffect(() => {
    if (!tg) return;

    tg.BackButton.show();
    const handleBack = () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate(`/order/${orderId}`);
      }
    };
    tg.BackButton.onClick(handleBack);

    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate, orderId]);

  return (
    <Layout showNav={false}>
      <div className="flex-1 flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <div className={`w-full max-w-md ${CARD_CLASS} p-6 xs:p-8 md-mobile:p-10`}>
          {/* Пульсирующее сердце */}
          <div className="mb-6 xs:mb-8 flex justify-center">
            <Loader />
          </div>

          {/* Заголовок */}
          <h1 className="text-xl xs:text-2xl md-mobile:text-3xl font-bold text-slate-900 mb-3 xs:mb-4">
            Спасибо!
          </h1>

          {/* Описание */}
          <p className="text-sm xs:text-base md-mobile:text-lg text-slate-600 mb-2 max-w-xs mx-auto">
            Ваш чек отправлен на проверку
          </p>
          <p className="text-xs xs:text-sm text-slate-500 mb-8 xs:mb-10 max-w-xs mx-auto">
            Мы проверим платёж и отправим билеты в Telegram. Обычно это занимает
            несколько минут.
          </p>

          {/* Кнопка перехода к заказу */}
          <button
            onClick={() => navigate(`/order/${orderId}`)}
            className="btn-primary px-8 xs:px-10"
          >
            Перейти к заказу
          </button>
        </div>
      </div>
    </Layout>
  );
}
